import styles from "./carousel.module.less";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/a11y";
import "swiper/css/navigation";

type TBreakPointKey = 320 | 768 | 1024;
type TBreakPointValue = { slidesPerView: number; spaceBetween: number };

type TBreakpointConfig = Record<TBreakPointKey, TBreakPointValue>;

type TCarouselProps = {
  heading?: string;
  className?: string;
  items: Array<any>;
  breakpointConfig?: TBreakpointConfig;
};

const defaultBreakPoints: TBreakpointConfig = {
  320: {
    slidesPerView: 1,
    spaceBetween: 10,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 30,
  },
};

export const Carousel = ({ heading, className, items, breakpointConfig = defaultBreakPoints }: TCarouselProps) => {
  return (
    <div className={styles.wrapper}>
      {heading && <h2>{heading}</h2>}
      <Swiper
        modules={[Pagination, A11y, Navigation]}
        cssMode={true}
        navigation={{ enabled: true }}
        a11y={{ enabled: true }}
        pagination={{ enabled: true, clickable: true }}
        breakpoints={breakpointConfig}
        slidesPerView={1}
        spaceBetween={20}
        className={[className, styles.slider].join(" ")}
      >
        {items.map((item, index) => {
          return <SwiperSlide key={index}>{item}</SwiperSlide>;
        })}
      </Swiper>
    </div>
  );
};

export default Carousel;
